import { useTranslation } from 'react-i18next';
import { type ConfiguratorModuleSpecsFragment } from '../../../../api/fragments/ConfiguratorModuleSpecs';
import ApplicationModuleVehicleAssignments from '../shared/ApplicationModuleVehicleAssignments';

export type UpdateVehicleAssignmentsValue = {
    dealerVehicles: Record<string, string[]>;
};

export type VehicleAssignmentsProps = {
    module: ConfiguratorModuleSpecsFragment;
};

const VehicleAssignments = ({ module }: VehicleAssignmentsProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <ApplicationModuleVehicleAssignments
            module={module}
            noItemText={t('eventApplicationModuleDetails:tabs.vehicles.noData')}
        />
    );
};

export default VehicleAssignments;
